/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITabItemViewProps, TabItemType } from './tab-item';

const TabItemView: React.FC<ITabItemViewProps> = props => {
    const { tabItemType, tabSlots, TabContentContainer, TabHeaderContainer, TabItemContent, tabHeader } = props;

    switch (tabItemType) {
        case TabItemType.TabContent:
            return (
                <Module {...TabContentContainer} >
                    <Node {...TabItemContent}>
                        {tabSlots && tabSlots.tabItemContent && tabSlots.tabItemContent.length && (_renderTabItemContent(tabSlots.tabItemContent))}
                    </Node>
                </Module>
            );
        case TabItemType.TabHeader:
            return (
                <Module {...TabHeaderContainer} >
                    {tabHeader}
                </Module>
            );
        default:
            return null;
    }
};

const _renderTabItemContent = (items: React.ReactNode[]): JSX.Element | null => {
    return (
        <>
            {items && items.length > 0 ? (
                items.map((item: React.ReactNode, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            {item}
                        </React.Fragment>
                    );
                })
            ) : null}
        </>
    );
};
export default TabItemView;
